export default __webpack_public_path__ + "static/media/high-school-4.be3d8e20.jpg";